import { newModalFromString } from '../components/modal';
import Gift from '../checkout/gift';
export class DispoHelpers {
    run () {
        this.removeExternalItems();
        this.copyGiftOptions();
        this.giftOptionsModal();
        this.giftOptionsLabel();
        this.triggerPersonalizationRemoved();
    }

    triggerPersonalizationRemoved () {
        if ($('#personalizationRemoved').val() === 'standard') {
            $('.submit-shipping').trigger('click');
            $('html, body').animate({
                scrollTop: $('.shipping-contact-container-pickup').offset().top
            }, 1000);
        }
    }

    giftOptionsLabel () {
        var $giftContainer = $('.copy-wrapper-gift-container');
        $giftContainer.each(function () {
            var addedWrapItems = $(this).attr('data-addedwrapitems') !== '';
            var addedKitItems = parseInt($(this).attr('data-numaddedkititems')) > 0;
            $(this).find('[class*="js-wrapperGiftContainer-"]').addClass('hide');
            if (addedWrapItems && addedKitItems) {
                $(this).find('.js-wrapperGiftContainer-wrappedGiftkit').removeClass('hide');
            } else if (addedWrapItems) {
                $(this).find('.js-wrapperGiftContainer-wrappedNoGiftkit').removeClass('hide');
            } else if (addedKitItems) {
                $(this).find('.js-wrapperGiftContainer-giftKitNotWrapped').removeClass('hide');
            }
        });
    }

    isDispoActive () {
        return $('#isDispoCountry').val() === 'true';
    }

    handleDispoStores () {
        var noDispoArrival = $('.is-store-method .noDispoArrivalLabel').val() || '';
        noDispoArrival = noDispoArrival.split('-')[1] !== undefined ? noDispoArrival.split('-')[1] : noDispoArrival;
        if (noDispoArrival !== '') {
            $('.result:not(.is-bopis)').find('.js-store-dispo-info-collection').html(noDispoArrival);
        } else {
            var noDispoArivalLabel = $('.shipping-method-selected .js-shipping-method').attr('data-visiblePickableText') || '';
            $('.result:not(.is-bopis)').find('.cc-findInStoreResultsCheckout-bopis').html(noDispoArivalLabel);
        }
    }

    removeExternalItems () {
        $('.js-remove-external-items-modal').insertAfter('.productPreviewLongDistance');
        $('.js-remove-external-items-modal').on('click', function (e) {
            e.preventDefault();

            const htmlContent = $('#removeExternalItems').clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false);
            $('.tingle-modal-box').addClass('rightModalAttribute');
            $('.tingle-modal-box').addClass('removeExternalItemsModal');
            modal.open();
            $.spinner().stop();
            $(modal.modal).css({
                'z-index': '4000'
            });
            $(modal.modalBox).css({
                'padding': '16px'
            });
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });

            const productData = $(e.currentTarget).closest('.checkout-product-summary').find('.analytics.checkout-product').data();

            $(modal.modalBox).on('click', '.js-remove-external-items', function (e) {
                e.stopPropagation();
                $.spinner().start();

                const url = $(e.currentTarget).data('url');
                const urlnotification = $(e.currentTarget).data('urlnotification');

                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $('body').trigger('product:removeExternalItemSuccessfully', { ...data, productData });
                        modal.close();
                        showRemoveExternalNotification(urlnotification);
                        modal.destroy();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
        });
    }

    selectBopisStore () {
        const htmlContent = $('#removePersonalizationModal').clone().html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false);
        $(modal.modalBox).addClass('rightModalAttribute');
        $('.tingle-modal-box').addClass('removePersonalizationModal cc-removePersonalizationModal');
        modal.open();
        $.spinner().stop();
        $(modal.modal).css('z-index', '4000');
        $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.js-choose-remove', (e) => {
            var isPersonalizationRemoval = $('#remove-personalization').prop('checked');
            isPersonalizationRemoval ? $('.js-remove-personalization').trigger('click') : $('.js-remove-bopis').trigger('click');
            e.preventDefault();
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.js-remove-personalization', (e) => {
            let url = $(e.currentTarget).data('url');
            let payload = {};
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: payload,
                success: data => {
                    $('.personalization-item').remove();
                    $('.fnCartOptions-personalization').hide();
                    $('.personalized-attributes').remove();
                    $('.personalizationAlert').hide();
                    $('.personalization-row').hide();
                    $('.total-box-body-item .grand-total-sum').text(data.totalGrossPrice);
                    $('.findinstore-form-container .modal-close').trigger('click');
                    $('.shipping-content .submit-shipping').trigger('click');
                    $.spinner().stop();
                    var modalOpened = 'paypal';
                    if ($('.amazon-confirm-express').css('display') !== 'none') {
                        modalOpened = 'amazon';
                    }
                    if ($('.klarna-confirm-express').css('display') !== 'none') {
                        modalOpened = 'klarna';
                    }
                    if ($('.page').data('action').indexOf('Checkout') > -1) {
                        modalOpened = 'standard';
                    }
                    var redirect = window.location.href;
                    var fragment = redirect.split('#')[1];
                    redirect = redirect.split('#')[0];
                    if (redirect.indexOf('?') > -1) {
                        redirect = redirect + '&personalizationRemoved=' + modalOpened;
                    } else {
                        redirect = redirect + '?personalizationRemoved=' + modalOpened;
                    }
                    redirect = redirect + '#' + fragment;

                    if ($('.page').attr('data-action').indexOf('Cart') > -1 || $('.page').attr('data-action').indexOf('Checkout') > -1) {
                        window.location.href = redirect;
                    } else {
                        location.reload();
                    }
                },
                error: data => {
                    $.spinner().stop();
                }
            }).then(function () {
                $.spinner().stop();
            });
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.js-remove-bopis', (e) => {
            let url = $(e.currentTarget).data('url');
            let payload = {};
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: payload,
                success: data => {
                    var noBopisLabel = $('#personalizationRemovedNoBopisLabel').val();
                    var completeNoDispoArrivalLabel = $('#completeNoDispoArrivalLabel').val();
                    $('.shipping-method-estimated-arrive').html(completeNoDispoArrivalLabel);
                    $('.shipping-method-selected .estimated-delivery').html(noBopisLabel);
                    $('.store-info').removeClass('is-bopis');
                },
                error: data => {
                    $.spinner().stop();
                }
            }).then(function () {
                $.spinner().stop();
            });
            modal.close();
            modal.destroy();
        });
    }

    copyGiftOptions () {
        if ($('#isDispoCountry').val() !== 'false') {
            var wrapperGiftContainer = $('.wrapper-gift-container').html();
            $('.copy-wrapper-gift-container').html(wrapperGiftContainer);
            Gift.run();
            $('.wrapper-gift-container').addClass('hidden');
        }
    }

    updateGiftCtas (e) {
        var addedwrapitems = $(e.currentTarget).parents('.copy-wrapper-gift-container').attr('data-addedwrapitems');
        var addedkititems = $(e.currentTarget).parents('.copy-wrapper-gift-container').attr('data-numaddedkititems');
        addedkititems = parseInt(addedkititems) > 0 ? 'true' : 'false';
        if (addedwrapitems) {
            $('.js-wrap-links').removeClass('hide');
            $('.js-wrap-buttons').addClass('hide');
        } else {
            $('.js-wrap-links').addClass('hide');
            $('.js-wrap-buttons').removeClass('hide');
        }
        if (addedkititems === 'true') {
            $('.js-kit-buttons').addClass('hide');
            $('.js-kit-links').removeClass('hide');
        } else {
            $('.js-kit-buttons').removeClass('hide');
            $('.js-kit-links').addClass('hide');
        }
    }

    giftOptionsModal () {
        var _self = this;
        $('.js-openGiftOptionsModal').on('click', function (e) {
            e.preventDefault();
            $('.chosen-gift-box').removeClass('chosen-gift-box');
            $('[class*="js-product-giftwrap-container-"]').addClass('hidden');
            $(e.currentTarget).addClass('chosen-gift-box');
            var numaddedkititems = $('.chosen-gift-box').parents('.copy-wrapper-gift-container').attr('data-numaddedkititems') || '0';
            $('.js-quantity-value').html(numaddedkititems);
            $('.gift-kit-quantity').toggleClass('hide', numaddedkititems === 0).text('(' + numaddedkititems + ')');

            const htmlContent = $('#giftOptionsModal').clone().html();
            // create and open dispo gift options modal
            const modal = newModalFromString(htmlContent, false);
            $('.tingle-modal-box').addClass('rightModalAttribute');
            $('.tingle-modal-box').addClass('cc-giftOptionsModal');
            // Use the giftWrap button for modal instead of the regular one
            $('.cc-giftWrapOption').addClass('hidden');
            $('.js-openGiftWrap-regularFlowButton').addClass('hidden');
            $('.js-openGiftWrap-dispoFlowButtonModal').removeClass('hidden');
            $('.cc-openGiftKit-dispoFlowButtonModal').addClass('hidden');
            $('.open-gift-wrap').addClass('cc-openGiftWrapModal');
            $('.cc-giftWrapOption_button').removeClass('large-5');
            // Use the giftKit button for modal instead of the regular one
            $('.cc-giftKitOption').addClass('hidden');
            $('.js-openGiftKit-regularFlowButton').addClass('hidden');
            $('.js-openGiftKit-dispoFlowButtonModal').removeClass('hidden');
            $('.open-gift-kit').addClass('cc-openGiftKitModal');
            $('.cc-giftKitOption_button').removeClass('large-5');
            modal.open();
            Gift.run();
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                $('.cc-giftWrapOption').removeClass('hidden');
                $('.js-openGiftWrap-regularFlowButton').removeClass('hidden');
                $('.js-openGiftWrap-dispoFlowButtonModal').addClass('hidden');
                $('.cc-openGiftKit-dispoFlowButtonModal').removeClass('hidden');
                $('.open-gift-wrap').removeClass('cc-openGiftWrapModal');
                $('.cc-giftWrapOption_button').addClass('large-5');

                $('.cc-giftKitOption').removeClass('hidden');
                $('.js-openGiftKit-regularFlowButton').removeClass('hidden');
                $('.js-openGiftKit-dispoFlowButtonModal').addClass('hidden');
                $('.open-gift-kit').removeClass('cc-openGiftKitModal');
                $('.cc-giftKitOption_button').addClass('large-5');
                modal.close();
                modal.destroy();
            });
            _self.updateGiftCtas(e);
        });
    }

    removeNotMainPersonalization () {
        const htmlContent = $('#cartRemoveNotMainPersonalization').clone().html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false, ['indexRemovePersonalization']);
        $(modal.modalBox).addClass('rightModalAttribute cartRemoveNotMainPersonalization cc-cartRemovePersonalization');
        $(modal.modal).css('z-index', '4000');
        modal.open();
        $.spinner().stop();
        $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.js-remove-personalization', (e) => {
            let url = $(e.currentTarget).data('url');
            let payload = {};
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: payload,
                success: data => {
                    $('.fnCartOptions-personalization').remove();
                    $('.personalized-attributes').remove();
                    $('.personalization-item').remove();
                    $('.personalizationAlert').hide();
                    $('.personalization-row').hide();
                    $('.total-box-body-item .grand-total-sum').text(data.totalGrossPrice);
                    $('.findinstore-form-container .modal-close').trigger('click');
                    $('.shipping-content .submit-shipping').trigger('click');
                    $('.js-expressButtonContinue').trigger('click');
                    $.spinner().stop();
                    var modalOpened = 'paypal';
                    if ($('.amazon-confirm-express').css('display') !== 'none') {
                        modalOpened = 'amazon';
                    }
                    if ($('.klarna-confirm-express').css('display') !== 'none') {
                        modalOpened = 'klarna';
                    }
                    if ($('.page').data('action').indexOf('Checkout') > -1) {
                        modalOpened = 'standard';
                    }
                    var redirect = window.location.href;
                    var fragment = redirect.split('#')[1];
                    redirect = redirect.split('#')[0];
                    if (redirect.indexOf('?') > -1) {
                        redirect = redirect + '&personalizationRemoved=' + modalOpened;
                    } else {
                        redirect = redirect + '?personalizationRemoved=' + modalOpened;
                    }
                    redirect = redirect + '#' + fragment;

                    if ($('.page').attr('data-action').indexOf('Cart') > -1 || $('.page').attr('data-action').indexOf('Checkout') > -1) {
                        window.location.href = redirect;
                    } else {
                        location.reload();
                    }
                },
                error: data => {
                    $.spinner().stop();
                }
            }).then(function () {
                $.spinner().stop();
            });
            modal.close();
            modal.destroy();
        });
    }
}

function showRemoveExternalNotification (urlnotification) {
    $.ajax(urlnotification).then(data => {
        $('body').append(data);
        let offsetTop = 12;
        offsetTop = $('.js-mainHeader').outerHeight() + 10;
        $('.js-external-product-remove-notification').css({
            top: offsetTop,
        });
        function closeNotification () {
            $('.js-external-product-remove-notification').off('click', '.js-close-notification');
            $('.js-external-product-remove-notification').remove();
        }
        $('.js-external-product-remove-notification').on('click', '.js-close-notification', closeNotification);
        location.reload();
        $.spinner().stop();
    });
}

const dispoHelpers = new DispoHelpers();
export default dispoHelpers;
